export default __webpack_public_path__ + "static/image 3-740f4bf71985f5d6456c2270f546b233.png";